<template>
  <div>
    <!-- :totalPages="productsbycategory.productsbycategory.total" -->
    <!-- :data="getProduct" -->
    <!-- :loading="loading" -->
    <!-- @page-selected="readItems" -->
    <!-- @page-selected="readItems" -->
    <va-card>
      <va-data-table
        :fields="fields"
        :data="reasons"
        class="va-table va-table--hoverable va-table--clickable"
        api-mode
      >
        <template slot="id" slot-scope="props">
          <span>{{ props.rowData.id }}</span>
        </template>
        <template slot="icon" slot-scope="props">
          <img
            v-if="props.rowData.icon"
            :src="props.rowData.icon.url"
            style="width: 40px; height: 40px; object-fit: contain"
            alt="icon"
          />
          <span v-else style="color: #999">—</span>
        </template>
        <template slot="name" slot-scope="props">
          <span>{{ props.rowData.name }}</span>
        </template>
        <template slot="actions" slot-scope="props">
          <va-button
            @click="updateReason(props.rowData)"
            flat
            small
            color="gray"
            icon="fa fa-pencil"
          />
          <va-button
            @click="removeReason(props.rowData.slug)"
            flat
            small
            color="gray"
            icon="fa fa-trash"
          />
        </template>
      </va-data-table>
    </va-card>

    <va-modal v-model="showUpdateModal" size="large" hide-default-actions>
      <update-reason
        v-model="changesValReason"
        @action="reasonActions"
      ></update-reason>
    </va-modal>
    <!-- <va-modal
      v-model="showCreateForm"
      size="large"
      hide-default-actions
    >
      <create-reason @hide="hideOrderStatusModal"></create-reason>

    </va-modal> -->
  </div>
</template>

<script>
import api from "@/api/axios";
import { mapActions } from "vuex";
import updateReason from "./update-reason.vue";
// var slugify = require('slugify')
export default {
  components: { updateReason },
  props: {
    reasons: {
      type: Array,
      require: true,
      default: () => [],
    },
  },
  data() {
    return {
      changesValReason: null,
      showCreateForm: false,
      showUpdateModal: false,
      showOrderStatusModal: false,
      currReason: {},
    };
  },
  filters: {
    truncate(value, size) {
      if (!value) return "";
      value = value.toString();

      if (value.length <= size) {
        return value;
      }
      return value.substr(0, size) + "...";
    },
  },
  computed: {
    fields() {
      return [
        {
          name: "__slot:id",
          title: "Номер",
        },
        {
          name: "__slot:icon",
          title: "Иконка",
          width: "80px",
        },
        {
          name: "__slot:name",
          title: "Название",
        },
        {
          name: "__slot:actions",
          title: "",
        },
      ];
    },
  },

  methods: {
    ...mapActions({
      fetchReasons: "reason/getReasons",
    }),
    async reasonActions(val) {
      if (val) {
        try {
          const data = {
            name: this.changesValReason.name,
          };
          if (this.changesValReason.icon_id !== undefined) {
            data.icon_id = this.changesValReason.icon_id;
          }
          await api.put(`/admin/reasons/${this.changesValReason.slug}`, data);
          await this.fetchReasons();
        } catch (error) {
          alert("Ошибка");
          return error;
        }
        this.showUpdateModal = false;
      } else {
        this.showUpdateModal = false;
      }
    },
    updateReason(reasonObj) {
      this.showUpdateModal = true;
      this.changesValReason = reasonObj;
    },
    hideUpdateModal() {
      this.showUpdateModal = false;
    },
    hideOrderModal() {
      this.showOrderModal = false;
    },
    hideOrderStatusModal() {
      this.showOrderStatusModal = false;
    },
    changeStatus(orderInfo) {
      this.currOrder = orderInfo;
      this.showOrderStatusModal = true;
    },
    async removeReason(reasonSlug) {
      if (confirm("Вы действительно хотите удалить ?")) {
        try {
          await api.delete(`/admin/reasons/${reasonSlug}`);
          await this.fetchReasons();
        } catch (error) {
          return error;
        }
      }
    },
  },
};
</script>

<style lang="scss">
.data-table-server-pagination---avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
@import "src/assets/scss/components/tooltip.scss";
</style>
<style lang="scss" scoped>
.success,
.warning,
.danger,
.primary {
  border-radius: 11px;
  padding: 5px;
}
.success {
  background-color: #4bb543;
  color: #fff;
}
.warning {
  background-color: #f2f236;
  color: #000;
}
.danger {
  background-color: #df4759;
  color: #fff;
}
.primary {
  background-color: #0275d8;
  color: rgb(255, 255, 255);
}
</style>
